import {
    call,
    put,
    takeLatest,
    takeEvery
} from 'redux-saga/effects';
import axios from 'axios';

// constants for endpoints
import {
    ORDER_PLANNING, PURCHASE_ORDERS,
} from '../../../components/global/Server/endpoints';
import { HTTP_SUCCESS } from "../../constants/global";


// constants for actions
import {
    LIST_ORDER_PLANNING,
    DELETE_ORDER_PLANNING,
    SAVE_ORDER_PLANNING,
    AUTOMATE_PURCHASE_ORDER, REMOVE_PURCHASE_ORDER, REFRESH_NEW_PURCHASE_ORDER, LIST_ALL_SHIPPED_FTL,
} from '../../constants/orderPlanning';

// secondary actions
import {
    storeAllOrderPlanning,
    storeAllShippedFTL,

} from '../../actions/orderPlanning';
import {
    requestStatus,
    hideError,
    showErrorMessage,
    setLoadingStatus,
} from '../../actions/global';
import { SERVER_FAILED_ERROR_MESSAGE } from '../../../pages/Dashboard/DashboardFinal/constants';


const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        "Authorization": `Bearer ${token}`
    }
}

const postRequest = (endpoint, data) => {
    return axios.post(endpoint, data, {
        headers: getHeaders()
    })
        .then(response => response)
}


const getRequest = (endpoint) => {
    return axios.get(endpoint, {
        headers: getHeaders()
    })
        .then(response => response);
}


function* listAllOrderPlanningSaga(action) {
    yield put(setLoadingStatus(true))
    try {
        const response = yield call(() => postRequest(ORDER_PLANNING.LIST_ORDER_PLANNING,action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeAllOrderPlanning(response.data.list));
        yield put(requestStatus(status));
    } catch (error) {
    } finally {
        yield put(setLoadingStatus(false))
    }
}

function* automatePurchaseOrderSaga(action) {
    try {
        const response = yield call(() => postRequest(ORDER_PLANNING.AUTOMATE_PURCHASE_ORDER, action.data))

        if (response.data.success) {
             if (action.callback && typeof action.callback === 'function') {
                 action.callback(response.data.success, response.data.purchaseOrder);
             }
        } else {
            action.callback( response.data.success,response.data.message);
        }
    } catch (e) {
        action.callback( false,SERVER_FAILED_ERROR_MESSAGE);
    }
}

function* refreshNewPurchaseOrderSaga(action) {
    try {
        const response = yield call(() => postRequest(ORDER_PLANNING.REFRESH_NEW_PURCHASE_ORDER, action.data))

        if (response.data.success) {
              if (action.callback) {
                  yield call(action.callback, true, response);
              }
        } else {
            action.callback( response.data.success,response.data.message);
        }
    } catch (e) {
        action.callback( false,SERVER_FAILED_ERROR_MESSAGE);
    }
}

function* removePurchaseOrderSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(PURCHASE_ORDERS.REMOVE_PURCHASE_ORDER, action.data))

        if (response.data.success) {
             if (action.callback && typeof action.callback === 'function') {
                 action.callback(response.data.success,'');
             }
        } else {
            action.callback( response.data.success,response.data.message);
        }
    } catch (e) {
        action.callback( false,SERVER_FAILED_ERROR_MESSAGE);
    }
}

function* saveOrderPlanningSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(ORDER_PLANNING.SAVE_ORDER_PLANNING, action.data))

        if (response.data.success) {
             if (action.callback && typeof action.callback === 'function') {
                 action.callback(response.data.success,response.data.orderPlanningId);
             }

            yield put(storeAllOrderPlanning(response.data.list));
        } else {
            yield put(showErrorMessage(response.data.message))
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* deleteOrderPlanningSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(ORDER_PLANNING.DELETE_ORDER_PLANNING, action.orderPlanningId))
        if (response.data.success) {

            yield put(storeAllOrderPlanning(response.data.list));
        } else {
            yield put(showErrorMessage(response.data.message))
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listAllShippedFTLSaga() {
    yield put(setLoadingStatus(true))
    try {
        const response = yield call(() => getRequest(ORDER_PLANNING.LIST_SHIPPED_FTL));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeAllShippedFTL(response.data.ftlList));
        yield put(requestStatus(status));
    } catch (error) {
    } finally {
        yield put(setLoadingStatus(false))
    }
}


export default function* orderPlanningSagas() {
    yield takeLatest(LIST_ORDER_PLANNING, listAllOrderPlanningSaga);
    yield takeLatest(DELETE_ORDER_PLANNING, deleteOrderPlanningSaga);
    yield takeLatest(SAVE_ORDER_PLANNING, saveOrderPlanningSaga);
    yield takeLatest(AUTOMATE_PURCHASE_ORDER, automatePurchaseOrderSaga);
    yield takeLatest(REMOVE_PURCHASE_ORDER, removePurchaseOrderSaga);
    yield takeEvery(REFRESH_NEW_PURCHASE_ORDER, refreshNewPurchaseOrderSaga);
    yield takeLatest(LIST_ALL_SHIPPED_FTL, listAllShippedFTLSaga);
}
